import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { Territory } from '@/types/territory';

interface TerritoryState {
  activeTerritory: Territory | null;
  setActiveTerritory: (territory: Territory | null) => void;
}

/**
 * Store du territoire actif, persisté dans le localStorage.
 *
 * La persistance évite de perdre le territoire sélectionné à chaque
 * rafraîchissement de page (sur un outil de décision, on doit retrouver son
 * territoire). Au premier chargement sans territoire persisté, activeTerritory
 * reste `null` et TerritorySelector auto-sélectionne la commune par défaut.
 */
export const useTerritoryStore = create<TerritoryState>()(
  persist(
    (set) => ({
      activeTerritory: null,
      setActiveTerritory: (activeTerritory) => set({ activeTerritory }),
    }),
    { name: 'terravision_active_territory' },
  ),
);
